<!-- Bottom Navigation Bar -->
<div class="fixed bottom-0 left-0 right-0 z-50 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700">
    <div class="flex items-center justify-around h-16 px-1">
        @for (item of navigation; track item.id) {
            <a
                [routerLink]="item.link"
                routerLinkActive="active"
                class="relative flex flex-col items-center justify-start flex-1 min-w-0 h-full pt-1 transition-colors duration-200"
                [class.text-blue-600]="isActive(item)"
                [class.text-gray-600]="!isActive(item)"
                [class.dark:text-blue-400]="isActive(item)"
                [class.dark:text-gray-400]="!isActive(item)"
            >
                <!-- Icon -->
                <mat-icon
                    [svgIcon]="getIcon(item)"
                    class="w-6 h-6 mb-1 flex-shrink-0"
                    [class.text-blue-600]="isActive(item)"
                    [class.text-gray-600]="!isActive(item)"
                    [class.dark:text-blue-400]="isActive(item)"
                    [class.dark:text-gray-400]="!isActive(item)"
                ></mat-icon>

                <!-- Text: a single line at 10px; the ellipsis is only a safety net for very narrow screens (min-w-0 on the tab lets it apply) -->
                <span
                    class="text-[10px] font-medium leading-tight text-center truncate max-w-full"
                    [class.text-blue-600]="isActive(item)"
                    [class.text-gray-600]="!isActive(item)"
                    [class.dark:text-blue-400]="isActive(item)"
                    [class.dark:text-gray-400]="!isActive(item)"
                >
                    {{ item.title }}
                </span>

                <!-- Active indicator (decorative, out of flow) -->
                @if (isActive(item)) {
                    <div class="absolute bottom-1 left-1/2 -translate-x-1/2 w-1 h-1 bg-blue-600 dark:bg-blue-400 rounded-full"></div>
                }
            </a>
        }
    </div>
</div>

<!-- Spacer to prevent content from being hidden behind bottom navigation -->
<div class="h-16"></div>
